export const GENERATE_CRED_SHOPEE_REQUEST = 'GENERATE_CRED_SHOPEE_REQUEST'
export const CREATE_GENERATE_CRED_SHOPEE_SUCCESS = 'CREATE_GENERATE_CRED_SHOPEE_SUCCESS'
export const CREATE_GENERATE_CRED_SHOPEE_ERROR = 'CREATE_GENERATE_CRED_SHOPEE_ERROR'

export const GENERATE_CRED_TIKTOK_REQUEST = 'GENERATE_CRED_TIKTOK_REQUEST'
export const CREATE_GENERATE_CRED_TIKTOK_SUCCESS = 'CREATE_GENERATE_CRED_TIKTOK_SUCCESS'
export const CREATE_GENERATE_CRED_TIKTOK_ERROR = 'CREATE_GENERATE_CRED_TIKTOK_ERROR'
